"use strict"

const originalForm = document.querySelector("product-form.product-form");
const stickyArea = document.getElementById("opt7_sticky_atc_section");
const duplicatedForm = originalForm.cloneNode(true);
const detailsWrap = duplicatedForm.querySelector(".pdp-details");
const yotpoWrap = duplicatedForm.querySelector(".yotpo.bottomLine");

const isElementInViewport = (el) => {
    let rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

window.addEventListener("load", (event) => {
    detailsWrap.parentNode.removeChild(detailsWrap);
    yotpoWrap.parentNode.removeChild(yotpoWrap);

    const cartIcon = document.createElement("p");
    cartIcon.classList = "d-flex align-items-center justify-content-center d-sm-none mb-0 text-white";
    cartIcon.style.width = "20px"
    cartIcon.style.height = "20px"
    cartIcon.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 576 512\"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d=\"M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z\"/></svg>";
    duplicatedForm.querySelector("button[type='submit'] .add-text").classList.remove("d-flex");
    duplicatedForm.querySelector("button[type='submit'] .add-text").classList.add("d-none");
    duplicatedForm.querySelector("button[type='submit'] .add-text").classList.add("d-sm-flex");
    duplicatedForm.querySelector("button[type='submit']").classList.add("p-0")
    duplicatedForm.querySelector("button[type='submit']").classList.add("p-sm-2")
    duplicatedForm.querySelector("button[type='submit']").prepend(cartIcon)

    duplicatedForm.querySelector("button[type='submit']").addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        originalForm.querySelector("button[type='submit']").click();
        setTimeout(() => {
            duplicatedForm.querySelector('[data-qty-input]').value = 1;
        }, 500)
    })

    duplicatedForm.querySelectorAll("[data-qty-btn]").forEach(item => {
        item.addEventListener("click", (e) => {
            const action = e.currentTarget.dataset.for;
            originalForm.manageQtyBtnSticky(action, originalForm);
        })
    })

    originalForm.querySelectorAll("[data-qty-btn]").forEach(item => {
        item.addEventListener("click", (e) => {
            const action = e.currentTarget.dataset.for;
            duplicatedForm.manageQtyBtnSticky(action, duplicatedForm);
        })
    })

    stickyArea.appendChild(duplicatedForm);

    console.info(
        `%c Optimum7 Sticky ATC Initialized`,
        'color: #FFF; background:#ff9800;line-height:1.5;font-family:sans-serif;font-size:16px;font-weight:700;padding:6px 10px',
    );
});

window.addEventListener("scroll", () => {
    const atcButton = originalForm.querySelector("button[type='submit']")
    const isSticky = !isElementInViewport(atcButton);
    if (document.querySelector('[title="chat widget"]')) {
        document.querySelector('[title="chat widget"]').style.transition = "all 350ms ease";
    }
    if (stickyArea) {
        if (isSticky) {
            stickyArea.classList.add("sticky");
            if (document.querySelector('[title="chat widget"]')) {
                document.querySelector('[title="chat widget"]').style.bottom = "90px";
            }
        } else {
            stickyArea.classList.remove("sticky");
            if (document.querySelector('[title="chat widget"]')) {
                document.querySelector('[title="chat widget"]').style.bottom = "20px";
            }
        }
    }
})